var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-content header-clear-medium"},[_c('div',[_c('div',{staticClass:"d-flex justify-content-center"},[_c('div',{staticClass:"preloader-l"},[_c('div',{staticClass:"spinner-border color-blue-dark",staticStyle:{"border-width":"7px"},attrs:{"role":"status"}})])])])])
}]

export { render, staticRenderFns }